import { isNode } from 'client/utils/environment';

const SCOPE = {
  client: 'client',
  server: 'server',
};

const scope = isNode() ? SCOPE.server : SCOPE.client;

export const getCurrentScope = () => scope;
export const getCurrentState = state => state.$profiler[getCurrentScope()];
